import configs from "../configs/configs";
import axios from "axios";
import storage from "../common/storage.js";
let instance = axios.create({
    baseURL: configs.baseURL,
});

// 添加一个请求拦截器
instance.interceptors.request.use(
    config => {
        let token = storage.getToken();
        if (token) {
            config.headers.Authorization = "Bearer " + token;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 添加一个响应拦截器
instance.interceptors.response.use(
    res => {
        if (res.data.error_code == 102) {
            storage.removeToken();
        }
        return res;
    },
    err => {
        return Promise.reject(err);
    }
);

//基地址
/**
 * @param path {string} path
 * @param opts {Object} options
 * @return {?Object}
 *
 * @description
 * Normalizes the given path, returning a regular expression
 * and the original path.
 *
 * Inspired by pathRexp in visionmedia/express/lib/utils.js.
 */
let pathReplace = function(path, opts) {
    let newPath = path;
    const { ...obj } = opts;
    if (obj == undefined || obj == null) {
        return newPath;
    } else {
        let newUrl = "";
        let urlList = [];
        urlList = newPath.split("/");
        for (let i = 1; i < urlList.length; i++) {
            if (urlList[i][0] == ":") {
                let str = urlList[i].slice(1);
                newUrl = newUrl + "/" + obj[str];
            } else {
                newUrl = newUrl + "/" + urlList[i];
            }
        }
        return newUrl;
    }
};

// 处理http请求
let config = function(config, params) {
    //提取接口url路径
    const { ...obj } = params;
    let url = pathReplace(config.url, obj),
    headers = {};

    if(config.version) {
        headers['Accept'] = 'application/vnd.indra-version.V' + config.version + '+json';
        config.headers = headers;
    }
    return {
        // 发送请求
        request: function(data) {
            let { ...newConfig } = config;
            newConfig.url = url;
            if (data) {
                newConfig.params = data.params ? data.params : "";
                newConfig.data = data.data ? data.data : "";
            }
            //执行http接口请求
            return instance(newConfig).then(successCallback, errorCallback);
        }
    };
};

// 请求成功回调
const successCallback = result => {
    return new Promise((resolve) => {
        resolve(result.data);
    })
};

// 请求失败回调
const errorCallback = result => {
    return new Promise((reject) => {
        console.warn(`request fail: \n`, result)
        // reject(result);
    })
};

export default {
    config: config
};




// WEBPACK FOOTER //
// ./src/utils/api-util.js